import fileSaver from 'file-saver';
import {FILE_NAME, HEADER_CONTENT_DISPOSITION} from "./constants/storage";

const saveFileFromBlob = (blobResponse) => {
    const url = window.URL.createObjectURL(new Blob([blobResponse.data]));
    const fileName = blobResponse.headers[HEADER_CONTENT_DISPOSITION].split(FILE_NAME)[1];

    fileSaver.saveAs(url, fileName);
};

export default saveFileFromBlob;